export const replaceVariables = (str: string, obj: { [key: string]: unknown; }) => {
   return str?.replaceAll(/\${\w+}/g, (v: string) => {
      const key = v?.replaceAll(/\${|}/g, "");
      return String(obj?.[key]);
   });
};
